import { render, staticRenderFns } from "./quick-details-smoking.vue?vue&type=template&id=c3308a76&scoped=true"
import script from "./quick-details-smoking.vue?vue&type=script&lang=ts"
export * from "./quick-details-smoking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3308a76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\WebDev\\Source\\PeppermillReno.com\\[DEV]\\[WEB] PeppermillReno.com DEV\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3308a76')) {
      api.createRecord('c3308a76', component.options)
    } else {
      api.reload('c3308a76', component.options)
    }
    module.hot.accept("./quick-details-smoking.vue?vue&type=template&id=c3308a76&scoped=true", function () {
      api.rerender('c3308a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "library/js/components/view-room-details/quick-details-smoking.vue"
export default component.exports